import { render, staticRenderFns } from "./PurchaseMailModal.vue?vue&type=template&id=a148b094&scoped=true&"
import script from "./PurchaseMailModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseMailModal.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseMailModal.vue?vue&type=style&index=0&id=a148b094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a148b094",
  null
  
)

export default component.exports